import React, { FC, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import { getImgixImageData, getImgixUrl } from "@utils"

import useCommonUrlsAndNumbers from "@hooks/useCommonUrlsAndNumbers"

import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "@components/Button/Button"
import Modal from "@components/Modal/Modal"
import Prefooter from "@components/Prefooter/Prefooter"
import RevealArea from "@components/RevealArea/RevealArea"
import Wistia from "@components/Wistia/Wistia"

import "./DefaultPrefooter.scss"

const DefaultPrefooter: FC = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false)
  const { demoUrl, signupPlusUrl } = useCommonUrlsAndNumbers()
  return (
    <RevealArea>
      <>
        <div
          className="DefaultPrefooter"
          style={{
            "--DefaultPrefooter--noise-overlay": `url("${getImgixUrl("/images/noise-overlay.png")}")`,
          }}
        >
          <Prefooter
            bgImgLeftPath="/images/components/prefooters/DefaultPrefooter/DefaultPrefooter--bg-left-24.png"
            bgImgRightPath="/images/components/prefooters/DefaultPrefooter/DefaultPrefooter--bg-right-24.png"
            bgImgWidth={770}
            bodyText={{ bodyText: "Learn the platform in less than&nbsp;an&nbsp;hour.<br>Become a <em>power user</em> in less&nbsp;than&nbsp;a&nbsp;day." }}
            title="Start for Free"
          >
            <div className="buttons-container">
              <Button
                href={signupPlusUrl || "/"}
                size={BUTTON_SIZES.L}
              >
                Start for Free
              </Button>
              <Button
                className="demo-button"
                href={demoUrl || "/"}
                size={BUTTON_SIZES.L}
                variant={BUTTON_VARIANTS.SECONDARY}
              >
                <>
                  <div className="gradient-border" />
                  Book a Demo
                </>
              </Button>
            </div>
          </Prefooter>
          <div className="DefaultPrefooter--graphic container">
            <div className="card">
              <div className="avatars">
                <GatsbyImage
                  alt=""
                  role="presentation"
                  image={getImgixImageData(
                    "/images/components/prefooters/DefaultPrefooter/DefaultPrefooter--graphic-avatar-left.png",
                    88,
                    1
                  )}
                />
                <div className="status-animation">
                  <div className="status-ring" />
                  <div className="status-ring" />
                  <GatsbyImage
                    alt=""
                    role="presentation"
                    image={getImgixImageData(
                      "/images/components/prefooters/DefaultPrefooter/DefaultPrefooter--graphic-avatar-right.png",
                      88,
                      1
                    )}
                  />
                </div>
              </div>
              <div className="card-top">
                <img
                  alt=""
                  className="card-title"
                  loading="lazy"
                  role="presentation"
                  src="/images/components/prefooters/DefaultPrefooter/DefaultPrefooter--graphic--title.svg"
                />
                <img
                  alt=""
                  className="card-tags"
                  loading="lazy"
                  role="presentation"
                  src="/images/components/prefooters/DefaultPrefooter/DefaultPrefooter--graphic--tags.svg"
                />
              </div>
            </div>
          </div>
        </div>
        {isVideoModalOpen && (
          <Modal
            onClose={() => setIsVideoModalOpen(false)}
            renderWithoutBox
          >
            <div className="WistiaPopover--Video">
              <Wistia autoPlay id="1y5tk06php" />
            </div>
          </Modal>
        )}
      </>
    </RevealArea>
  )
}

export default DefaultPrefooter
